import { useEffect, useState } from 'react';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { useLang } from '../services/lang';

// TODO: use local session?
let userClosedPopUpSession = false;

export default function MessengerRedirect() {
    const { dict } = useLang();
    const [isVisible, setIsVisible] = useState(false);
    const [platform, setPlatform] = useState<"android" | "ios" | "unknown">('unknown');
    const [currentUrl, setCurrentUrl] = useState('');

    useEffect(() => {
        if (userClosedPopUpSession) return;

        const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

        // Detection In-App browsers (Facebook, Messenger, Instagram)
        const isInstagram = (ua.indexOf('Instagram') > -1) || (ua.indexOf('IG_') > -1);
        const isFacebook = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);

        if (isInstagram || isFacebook) {
            // We are in Messenger!

            // OS detection
            const isAndroid = /android/i.test(ua);
            const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;

            if (isAndroid) setPlatform('android');
            if (isIOS) setPlatform('ios');

            // Prepare URL without protocol for Android Intent
            setCurrentUrl(window.location.href.replace(/^https?:\/\//, ''));
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    function handleClose() {
        userClosedPopUpSession = true;
        setIsVisible(false);
    }

    if (!isVisible) return null;

    return <div className="messenger-redirect">
        <div className="block">
            <div className="close" onClick={handleClose}><Icon path={mdiClose} size={1} /></div>

            <p className='info'>{dict.messengerRedirectInfo}</p>

            {platform === 'android' && <a className='button' href={`intent://${currentUrl}#Intent;scheme=https;end`} >
                {dict.messengerRedirectButton}
            </a>}
            {platform !== 'android' && <p>
                {dict.messengerRedirectHelp}
            </p>}
        </div>
    </div>;
}
